import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { onActualizacion, aplicarActualizacion } from '../lib/appUpdate';

// Banda superior "Hay una versión nueva de HUECO · Actualizar" cuando el SW detecta un deploy.
export function ActualizacionBanner() {
  const { t } = useTranslation();
  const [hay, setHay] = useState(false);
  useEffect(() => onActualizacion(() => setHay(true)), []);
  if (!hay) return null;
  return (
    <div className="update-banner" data-testid="update-banner" role="status">
      <span>{t('actualizacion.disponible')}</span>
      <button className="btn sm" onClick={aplicarActualizacion} data-testid="update-btn">
        <RefreshCw size={14} /> {t('actualizacion.boton')}
      </button>
    </div>
  );
}
